import { apiSlice } from "../api/apiSlice";

export const assignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => ({
        url: "/assignments",
        method: "GET",
      }),
    }),
    getAssignment: builder.query({
      query: (assignmentId) => ({
        url: `/assignments/${assignmentId}`,
        method: "GET",
      }),
    }),
    editAssignment: builder.mutation({
      query: ({ assignmentId, data }) => ({
        url: `/assignments/${assignmentId}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedAssignment } = await queryFulfilled;

          // update getAssignments catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                const draftAssignment = draft?.find(
                  (assignment) => assignment.id == updatedAssignment.id
                );
                draftAssignment.title = updatedAssignment.title;
                draftAssignment.video_id = updatedAssignment.video_id;
                draftAssignment.video_title = updatedAssignment.video_title;
                draftAssignment.totalMark = updatedAssignment.totalMark;
              }
            )
          );
          // update getAssignments catch pessimestically end
        } catch (error) {}
      },
    }),
    addAssignment: builder.mutation({
      query: (data) => ({
        url: `/assignments`,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedAssignment } = await queryFulfilled;

          // update updatedAssignment catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                draft?.push(updatedAssignment);
              }
            )
          );
          // update updatedAssignment catch pessimestically end
        } catch (error) {}
      },
    }),

    getVideoAssignment: builder.query({
      query: (id) => ({
        url: `/assignments?video_id_like=${id}`,
        method: "GET",
      }),
    }),

    getAssignmentMark: builder.query({
      query: ({ assignmentId, studentName }) => ({
        url: `/assignmentMark?assignment_id_like=${assignmentId}&student_name_like=${studentName}`,
        method: "GET",
      }),
    }),

    getAssignmentMarks: builder.query({
      query: () => ({
        url: `/assignmentMark/`,
        method: "GET",
      }),
    }),
    submitAssignmentMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignmentMark/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedAssignmentMark } = await queryFulfilled;

          // update getAssignments catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (draft) => {
                const draftAssignmentMark = draft?.find(
                  (assignmentMark) =>
                    assignmentMark.id == updatedAssignmentMark.id
                );
                draftAssignmentMark.mark = updatedAssignmentMark.mark;
                draftAssignmentMark.status = updatedAssignmentMark.status;
              }
            )
          );
          // update getAssignments catch pessimestically end
        } catch (error) {}
      },
    }),

    submitAssignment: builder.mutation({
      query: ({ assignmentId, studentName, data }) => ({
        url: `/assignmentMark`,
        method: "POST",
        body: data,
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: UpdatedAssignmentMark } = await queryFulfilled;

          // update assignmentMark catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMark",
              {
                assignmentId: arg?.assignmentId,
                studentName: arg?.studentName,
              },
              (draft) => {
                draft.push(UpdatedAssignmentMark);
              }
            )
          );
          // update assignmentMark catch pessimestically end
        } catch (error) {}
      },
    }),
    deleteAssignment: builder.mutation({
      query: (assignmentId) => ({
        url: `/assignments/${assignmentId}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: deletedAssignment } = await queryFulfilled;

          // update getAssignments catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                return draft.filter((assignment) => assignment.id !== arg);
              }
            )
          );
          // update getAssignments catch pessimestically end
        } catch (error) {}
      },
    }),
  }),
});

export const {
  useGetAssignmentQuery,
  useGetAssignmentsQuery,
  useSubmitAssignmentMutation,
  useGetAssignmentMarkQuery,
  useGetAssignmentMarksQuery,
  useDeleteAssignmentMutation,
  useGetVideoAssignmentQuery,
  useEditAssignmentMutation,
  useAddAssignmentMutation,
  useSubmitAssignmentMarkMutation,
} = assignmentsApi;
